import { render } from "./GridItem.vue?vue&type=template&id=5c578ed7&scoped=true&ts=true"
import script from "./GridItem.vue?vue&type=script&lang=ts"
export * from "./GridItem.vue?vue&type=script&lang=ts"

import "./GridItem.vue?vue&type=style&index=0&id=5c578ed7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c578ed7"]])

export default __exports__